export default __webpack_public_path__ + "static/media/play-button-dark-circle.6b09129a.svg";